import React from 'react';

import PracticeBadge from './PracticeBadge/PracticeBadge';
import { LiveBarPropsType } from './types';
import { LIVE } from '../../../config/constants';
import { SchedulePractice } from '../../../config/commonTypes';

const LiveBar = ({ events }: LiveBarPropsType) => {
  
  const livePractices = events ? events.filter((event) => event.status === LIVE) : [];
  const badges = livePractices.map((practice, index) => (
    <PracticeBadge practice={practice as SchedulePractice} key={index} liveBar />
  ));
  
  return (
    <div className="livebar">
      <div>
        <p> Live Practices <label id="livebar-quantity">{livePractices.length}</label></p>
      </div>
      <div className="live-card">{badges}</div>
      <div className="btn-bar">
        {/* <Button className="bar-gg"><i className="mdi mdi-chevron-left"></i></Button>
         <Button><i className="mdi mdi-chevron-right"></i></Button> */}
      </div>
    </div>
  );
};

export default LiveBar;
